import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'modal-delete-variety',
  templateUrl: './modal-delete-variety.component.html',
  styleUrls: ['./modal-delete-variety.component.scss'],
})
export class ModalDeleteVarietyComponent implements OnInit {
  varietyName?: string;
  constructor(
    public modalRef: MdbModalRef<ModalDeleteVarietyComponent>,
    private location: LocationStrategy
  ) {
    history.pushState(null, '', window.location.href);

    this.location.onPopState((event) => {
      this.modalRef.close();
    });
  }

  ngOnInit(): void {}
}
